// BlogsSection.jsx
import React, { useEffect, useState } from 'react';
import { useDoctorQuery } from '../../hooks/useDoctorQuery';
import drEasyApi from '../../Api/Customapi';
import { useDoctorContext } from '../../context/DoctorContext';
import BlogCard from '../Cards/BlogCard';
import { useTranslation } from 'react-i18next';

export default function BlogsSection() {
    const { t } = useTranslation();
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const { data: doctor } = useDoctorQuery();
    const { setHasBlogs } = useDoctorContext();

    useEffect(() => {
        const fetchBlogs = async () => {
            try {
                const res = await drEasyApi.get('/api/Blogs/GetCenterBlogs', {
                    params: { CenterId: doctor?.id },
                });
                setBlogs(res.data || []);
                if(res?.data?.length > 0){
                    setHasBlogs(true);
                }
            } catch (err) {
                console.error('Failed to load blogs', err);
            } finally {
                setLoading(false);
            }
        };

        if (doctor?.id) {
            fetchBlogs();
        }
    }, [doctor?.id]);

    // 🔒 Don't render the section if loading is done and no blogs exist
    if (!loading && blogs.length === 0) {
        setHasBlogs(false);
        return null;
    }

    return (
        <section className="bg-gradient-to-br py-16 px-4 sm:px-10 lg:px-20  flex flex-col justify-center items-center">
            <div id="blogs" className="text-center mb-14">
                <h2 className="text-4xl font-bold text-textPrimary tracking-tight">
                    {t('blogs.title')}
                </h2>
                <p className="mt-3 text-textPrimary/70 max-w-2xl mx-auto">
                    {t('blogs.subtitle')}
                </p>
            </div>

            {loading ? (
                <div className="text-center text-textPrimary">{t('blogs.loading')}</div>
            ) : (
                <div className="  mx-auto grid  justify-center items-center grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 md:gap-8 max-w-7xl px-4 md:px-8 lg:px-16">
                    {blogs.map((blog, index) => (
                        <BlogCard
                        id={blog.id}
                            key={index}
                            title={blog.title}
                            summary={blog.description}
                            date={blog.date}
                            image={blog.photoID}
                            index={index}
                        />
                    ))}
                </div>
            )}
        </section>
    );
}
